/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudArrowDownloadIcon20Solid = forwardRef('NetCloudArrowDownloadIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.5 8.5A4.5 4.5 0 0 0 5 13h4v4.086l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.616 2.616a2.25 2.25 0 0 0 3.182 0l2.616-2.616a1 1 0 0 0-1.414-1.414L11 17.086V13h3.5a5 5 0 1 0-.344-9.988A5.502 5.502 0 0 0 3.922 4.13 4.502 4.502 0 0 0 .5 8.5ZM11 13V7.75a1 1 0 1 0-2 0V13h2Z" })));
});
